<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><span>CONTENTS</span></p>
<p class="normal sgc-2"><span href="#/Text/title" title="Link target outside of Sample">Title Page</span></p>
<p class="normal sgc-2"><a href="#/Text/introduction">Introduction</a></p>
<p class="normal sgc-2"> </p>
<p class="normal sgc-2"><a class="sgc-3" href="#/Text/01_section">JUSTINE</a></p>
<p class="normal sgc-2"><a href="#/Text/02_note">Note</a></p>
<p class="normal sgc-2"><a href="#/Text/05_part1">Part I</a></p>
<p class="normal sgc-2"><a href="#/Text/06_part2">Part II</a></p>
<p class="normal sgc-2"><span href="#/Text/07_part3" title="Link target outside of Sample">Part III</span></p>
<p class="normal sgc-2"><span href="#/Text/08_part4" title="Link target outside of Sample">Part IV</span></p>
<p class="normal sgc-2"> </p>
<p class="normal sgc-2"><span class="sgc-3" href="#/Text/11_section02" title="Link target outside of Sample">BALTHAZAR</span></p>
<p class="normal sgc-2"><span href="#/Text/14_part1" title="Link target outside of Sample">Part I</span></p>
<p class="normal sgc-2"><span href="#/Text/14_part1#part1-01" title="Link target outside of Sample">I</span></p>
<p class="normal sgc-2"><span href="#/Text/15_II" title="Link target outside of Sample">II</span></p>
<p class="normal sgc-2"><span href="#/Text/16_III" title="Link target outside of Sample">III</span></p>
<p class="normal sgc-2"><span href="#/Text/17_IV" title="Link target outside of Sample">IV</span></p>
<p class="normal sgc-2"><span href="#/Text/18_V" title="Link target outside of Sample">V</span></p>
<p class="normal sgc-2"><span href="#/Text/19_part2VI" title="Link target outside of Sample">Part II</span></p>
<p class="normal sgc-2"><span href="#/Text/19_part2VI#vi" title="Link target outside of Sample">VI</span></p>
<p class="normal sgc-2"><span href="#/Text/20_VII" title="Link target outside of Sample">VII</span></p>
<p class="normal sgc-2"><span href="#/Text/21_VIII" title="Link target outside of Sample">VIII</span></p>
<p class="normal sgc-2"><span href="#/Text/22_IX" title="Link target outside of Sample">IX</span></p>
<p class="normal sgc-2"><span href="#/Text/23_part3X" title="Link target outside of Sample">Part III</span></p>
<p class="normal sgc-2"><span href="#/Text/23_part3X#x" title="Link target outside of Sample">X</span></p>
<p class="normal sgc-2"><span href="#/Text/24_XI" title="Link target outside of Sample">XI</span></p>
<p class="normal sgc-2"><span href="#/Text/25_part4XII" title="Link target outside of Sample">Part IV</span></p>
<p class="normal sgc-2"><span href="#/Text/25_part4XII#xii" title="Link target outside of Sample">XII</span></p>
<p class="normal sgc-2"><span href="#/Text/26_XIII" title="Link target outside of Sample">XIII</span></p>
<p class="normal sgc-2"><span href="#/Text/27_XIV" title="Link target outside of Sample">XIV</span></p>
<p class="normal sgc-2"> </p>
<p class="normal sgc-2"><span class="sgc-3" href="#/Text/32_section03" title="Link target outside of Sample">MOUNTOLIVE</span></p>
<p class="normal sgc-2"><span href="#/Text/34_note" title="Link target outside of Sample">Note</span></p>
<p class="normal sgc-2"><span href="#/Text/36_I" title="Link target outside of Sample">I</span></p>
<p class="normal sgc-2"><span href="#/Text/37_II" title="Link target outside of Sample">II</span></p>
<p class="normal sgc-2"><span href="#/Text/38_III" title="Link target outside of Sample">III</span></p>
<p class="normal sgc-2"><span href="#/Text/39_IV" title="Link target outside of Sample">IV</span></p>
<p class="normal sgc-2"><span href="#/Text/40_V" title="Link target outside of Sample">V</span></p>
<p class="normal sgc-2"><span href="#/Text/41_VI" title="Link target outside of Sample">VI</span></p>
<p class="normal sgc-2"><span href="#/Text/42_VII" title="Link target outside of Sample">VII</span></p>
<p class="normal sgc-2"><span href="#/Text/43_VIII" title="Link target outside of Sample">VIII</span></p>
<p class="normal sgc-2"><span href="#/Text/44_IX" title="Link target outside of Sample">IX</span></p>
<p class="normal sgc-2"><span href="#/Text/45_X" title="Link target outside of Sample">X</span></p>
<p class="normal sgc-2"><span href="#/Text/46_XI" title="Link target outside of Sample">XI</span></p>
<p class="normal sgc-2"><span href="#/Text/47_XII" title="Link target outside of Sample">XII</span></p>
<p class="normal sgc-2"><span href="#/Text/48_XIII" title="Link target outside of Sample">XIII</span></p>
<p class="normal sgc-2"><span href="#/Text/49_XIV" title="Link target outside of Sample">XIV</span></p>
<p class="normal sgc-2"><span href="#/Text/50_XV" title="Link target outside of Sample">XV</span></p>
<p class="normal sgc-2"><span href="#/Text/51_XVI" title="Link target outside of Sample">XVI</span></p>
<p class="normal sgc-2"> </p>
<p class="normal sgc-2"><span class="sgc-3" href="#/Text/52_section04" title="Link target outside of Sample">CLEA</span></p>
<p class="normal sgc-2"><span href="#/Text/55_I" title="Link target outside of Sample">I</span></p>
<p class="normal sgc-2"><span href="#/Text/60_II" title="Link target outside of Sample">II</span></p>
<p class="normal sgc-2"><span href="#/Text/61_III" title="Link target outside of Sample">III</span></p>
<p class="normal sgc-2"><span href="#/Text/62_IV" title="Link target outside of Sample">IV</span></p>
<p class="normal sgc-2"><span href="#/Text/63_V" title="Link target outside of Sample">V</span></p>
<p class="normal sgc-2"><span href="#/Text/64_VI" title="Link target outside of Sample">VI</span></p>
<p class="normal sgc-2"><span href="#/Text/65_VII" title="Link target outside of Sample">VII</span></p>
<p class="normal sgc-2"><span href="#/Text/66_VIII" title="Link target outside of Sample">VIII</span></p>
<p class="normal sgc-2"><span href="#/Text/67_1X" title="Link target outside of Sample">IX</span></p>
<p class="normal sgc-2"> </p>
<p class="normal sgc-2"><span href="#/Text/biography" title="Link target outside of Sample">A Biography of Lawrence Durrell</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6d11f9f2